<template>
  <div
    class="mb-0 px-2 tiss-subtitle"
    style="font-size: 7pt;
    background-color: gainsboro !important;
    -webkit-print-color-adjust: exact;"
  >{{ title }}</div>
</template>

<script>
export default {
  props: ["title"]
};
</script>
<style>
.tiss-subtitle {
  background-color: gainsboro;
}
</style>
